import React from 'react';
import { Github, Linkedin, Twitter } from 'lucide-react';

const teamMembers = [
  {
    id: 1,
    name: "Alex Morgan",
    role: "Founder & CEO",
    image: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    bio: "With over 15 years of experience in tech leadership, Alex founded TDMA to revolutionize how businesses leverage AI and web technologies.",
    socialLinks: {
      twitter: "#",
      linkedin: "#",
      github: "#"
    }
  },
  {
    id: 2,
    name: "Jamie Chen",
    role: "Lead AI Engineer",
    image: "https://images.pexels.com/photos/3785424/pexels-photo-3785424.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    bio: "Jamie specializes in developing cutting-edge AI solutions that solve complex business challenges and enhance user experiences.",
    socialLinks: {
      twitter: "#",
      linkedin: "#",
      github: "#"
    }
  },
  {
    id: 3,
    name: "Sam Rodriguez",
    role: "Senior UI/UX Designer",
    image: "https://images.pexels.com/photos/3771089/pexels-photo-3771089.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    bio: "Sam combines aesthetic sensibility with user-centric design principles to create interfaces that are both beautiful and intuitive.",
    socialLinks: {
      twitter: "#",
      linkedin: "#",
      github: "#"
    }
  },
  {
    id: 4,
    name: "Taylor Williams",
    role: "Full Stack Developer",
    image: "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    bio: "Taylor is an expert in modern web technologies with a passion for creating scalable, high-performance applications.",
    socialLinks: {
      twitter: "#",
      linkedin: "#",
      github: "#"
    }
  }
];

const Team: React.FC = () => {
  return (
    <section id="team" className="section bg-black relative">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
      
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="mb-6">Our Team</h2>
          <p className="text-white/70 text-lg">
            Meet the talented professionals behind TDMA who bring expertise, creativity, and dedication to every project.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div 
              key={member.id} 
              className="group animate-fade-in stagger-delay-1"
            >
              <div className="relative overflow-hidden rounded-xl mb-4">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="w-full aspect-square object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center p-6">
                  <div className="flex space-x-4">
                    <a href={member.socialLinks.twitter} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
                      <Twitter className="h-5 w-5" />
                    </a>
                    <a href={member.socialLinks.linkedin} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
                      <Linkedin className="h-5 w-5" />
                    </a>
                    <a href={member.socialLinks.github} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
                      <Github className="h-5 w-5" />
                    </a>
                  </div>
                </div>
              </div>
              
              <h3 className="text-xl font-bold">{member.name}</h3>
              <p className="text-white/70 mb-3">{member.role}</p>
              <p className="text-white/60 text-sm">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;